import { I18n } from '@calendly/i18n'
import { IconCreditCard } from '@calendly/ui/components/glyphs/IconCreditCard'
import { SwitchInput } from '@calendly/ui/components/switch-input'
import { BodyText, LabelText } from '@calendly/ui/components/typography'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { colorIconAction, colorIconSecondary } from '@calendly/ui/theme'
import classNames from 'classnames'
import { useState } from 'react'

import {
  cardActionsCss,
  cardContentCss,
  cardIconWrapperCss,
  requirePaymentCardCss,
  requirePaymentCardDisabledCss,
} from './styles'

export const RequirePaymentCard = ({
  checked = false,
  disabled = false,
  onChange,
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const label = I18n.t('publisher.event_type_editor_crud.payments.require_payment.title')
  const emphasize = checked || isHovered

  return (
    <label
      className={classNames(requirePaymentCardCss, {
        [requirePaymentCardDisabledCss]: disabled,
      })}
      data-testid="require-payment-card"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className={cardIconWrapperCss}>
        <UiIcon
          color={emphasize ? colorIconAction : colorIconSecondary}
          icon={IconCreditCard}
          size="medium"
          title=""
        />
      </div>
      <div className={cardContentCss}>
        <LabelText color={emphasize ? 'standard' : 'muted'}>{label}</LabelText>
        <BodyText color="muted" size="small">
          {I18n.t('publisher.event_type_editor_crud.payments.require_payment.description')}
        </BodyText>
      </div>
      <div className={cardActionsCss}>
        <SwitchInput
          aria-label={label}
          checked={checked}
          disabled={disabled}
          name="paymentSwitch"
          onChange={onChange}
        />
      </div>
    </label>
  )
}
